import { MediaType } from "@/generated/graphql";
import { AudioPreview } from "./AudioPreview";
import { FilePreview } from "./FilePreview";
import { ImagePreview } from "./ImagePreview";
import { VideoPreview } from "./VideoPreview";

/**
 * Common props for all preview components
 */
export interface MediaPreviewProps {
  /** Media URL (pre-signed S3 URL) */
  url: string;
  /** Filename for display */
  filename: string;
  /** Media type */
  type: MediaType;
  /** Duration in seconds (for audio/video) */
  duration?: number | null | undefined;
  /** MIME type for file icons */
  mimeType?: string | undefined;
  /** Preview variant */
  variant: "inline" | "full";
  /** Optional className */
  className?: string | undefined;
}

/**
 * MediaPreview - Registry component that renders appropriate preview based on type
 *
 * Routes to AudioPreview, ImagePreview, VideoPreview, or FilePreview
 * based on the media type.
 */
export function MediaPreview({
  url,
  filename,
  type,
  duration,
  mimeType,
  variant,
  className,
}: MediaPreviewProps) {
  switch (type) {
    case MediaType.Audio:
      return (
        <AudioPreview
          url={url}
          filename={filename}
          duration={duration}
          variant={variant}
          className={className}
        />
      );

    case MediaType.Image:
      return <ImagePreview url={url} filename={filename} variant={variant} className={className} />;

    case MediaType.Video:
      return (
        <VideoPreview
          url={url}
          filename={filename}
          duration={duration}
          variant={variant}
          className={className}
        />
      );

    case MediaType.File:
      return (
        <FilePreview
          url={url}
          filename={filename}
          mimeType={mimeType}
          variant={variant}
          className={className}
        />
      );

    default:
      return null;
  }
}

export default MediaPreview;
